<div class="chat-widget">
  @if (isOpen()) {
    <mat-card class="chat-panel mat-elevation-z8">
      <div class="chat-header">
        <div class="chat-title">
          <mat-icon fontSet="material-icons" fontIcon="chat"></mat-icon>
          <span>{{'TITLE.USER_GUIDE_CHAT' | translate}}</span>
        </div>

        <button
          mat-icon-button
          type="button"
          aria-label="Close chat"
          (click)="closeChat()">
          <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
        </button>
      </div>

      <div class="chat-messages" #messagesContainer>
        @for (message of messages(); track message.id) {
          @if (message.author === 'user') {
            <div class="message-row user">
              <div class="message-bubble user">
                <span class="chat-text">{{ message.text }}</span>
              </div>
              @if (authService.user$ | async; as user) {
                <img class="profile-picture"
                     [ngSrc]="user.picture"
                     width="35"
                     height="35"
                     alt="{{'TOOLTIP.PROFILE_PICTURE' | translate}}">
              }
            </div>
          } @else {
            <div class="message-row bot">
              <mat-card class="bot-avatar">
                <mat-icon fontSet="material-icons" fontIcon="smart_toy" class="avatar-icon"></mat-icon>
              </mat-card>
              <div class="message-bubble bot" [class.error]="message.error">
                @if (message.streaming) {
                  <span class="chat-streaming-text">{{ message.text }}</span>
                } @else {
                  <markdown
                    class="chat-markdown"
                    [inline]="true"
                    [data]="message.text">
                  </markdown>
                }
              </div>
            </div>
          }
        }

        @if (isLoading()) {
          <div class="message-row bot">
            <mat-card class="bot-avatar">
              <mat-icon fontSet="material-icons" fontIcon="smart_toy" class="avatar-icon"></mat-icon>
            </mat-card>
            <div class="message-bubble bot typing-indicator">
              <span class="typing-dot"></span>
              <span class="typing-dot"></span>
              <span class="typing-dot"></span>
            </div>
          </div>
        }
      </div>

      <div class="chat-composer">
        <mat-form-field appearance="outline" class="composer-field">
          <textarea
            matInput
            rows="2"
            [formControl]="messageControl"
            [placeholder]="('PLACEHOLDER.MESSAGE' | translate)"
            (keydown.enter)="onEnter($event)">
          </textarea>
        </mat-form-field>

        <button
          mat-fab
          type="button"
          aria-label="Send message"
          [disabled]="isLoading()"
          (click)="sendMessage()">
          <mat-icon fontSet="material-icons" fontIcon="send"></mat-icon>
        </button>
      </div>
    </mat-card>
  } @else {
    <button
      mat-fab
      class="chat-toggle-button"
      type="button"
      aria-label="Open chat"
      (click)="toggleChat()">
      <mat-icon fontSet="material-icons" fontIcon="smart_toy"></mat-icon>
    </button>
  }
</div>
